import { __assign } from "tslib";
import React from 'react';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './ModalLink.scss';
var ModalLink = function (props) { return (React.createElement(BiLink, __assign({ className: s['root'] }, props))); };
ModalLink.displayName = 'ModalLink';
export default ModalLink;
//# sourceMappingURL=ModalLink.js.map